import { ChartField } from 'src/app/types/chart.model'
import { NUM_MATCHED_ITEMS_VALUE_FIELD } from 'src/app/types/constants'
import { TargetComparison } from 'src/app/types/enums'
import { CHILD_JOB_FIELDS } from './job-lookup.model'

// processed = status converted to string
export interface ProcessedJobTask {
  id: number

  jobId: number
  jobNumber: string

  startDate?: Date
  endDate?: Date
  sentDate?: Date

  taskType: string // i.e. Task-Master Title. can be different between tasks if using task-code to filter

  status: string
  allocatedTo: string
  division: string
  stage: string | null
  vendor: string
  salesRep: string | null
  siteManager: string | null
}

const JOBTASK_CORE_FIELDS: ChartField[] = [
  {
    dataField: 'taskType',
    displayName: 'Task Type',
    dataType: 'string',
  },
  {
    dataField: 'status',
    displayName: 'Status',
    dataType: 'string',
  },
  {
    dataField: 'allocatedTo',
    displayName: 'Allocated To',
    dataType: 'string',
    isPersonField: true,
  },
  {
    dataField: 'vendor',
    displayName: 'Vendor',
    dataType: 'string',
  },
  {
    dataField: 'startDate',
    displayName: 'Start Date',
    dataType: 'date',
  },
  {
    dataField: 'endDate',
    displayName: 'End Date',
    dataType: 'date',
  },
  {
    dataField: 'sentDate',
    displayName: 'Sent Date',
    dataType: 'date',
  },
]

export const JOBTASK_ALL_FIELDS: ChartField[] = [...JOBTASK_CORE_FIELDS, ...CHILD_JOB_FIELDS]

export const JOBTASK_FILTER_FIELDS: ChartField[] = JOBTASK_ALL_FIELDS

export const JOBTASK_DATE_FILTER_FIELDS: ChartField[] = JOBTASK_ALL_FIELDS.filter(
  (jtf) => jtf.dataType === 'date'
)

export const JOBTASK_ARGUMENT_FIELDS: ChartField[] = [
  ...JOBTASK_CORE_FIELDS.filter(
    (jtf) => jtf.dataType === 'string' || jtf.dataType === 'date' || jtf.dataType === 'number'
  ),
  ...CHILD_JOB_FIELDS,
]

export const JOBTASK_VALUE_FIELDS: ChartField[] = [NUM_MATCHED_ITEMS_VALUE_FIELD]

export const TASK_DURATION_VALUE_FIELDS: ChartField[] = [{
  ...NUM_MATCHED_ITEMS_VALUE_FIELD,
  displayName: 'Average duration',
  defaultTargetComparison: TargetComparison.AtMost,
}]

export const JOBTASK_SERIES_GROUP_FIELDS: ChartField[] = JOBTASK_ALL_FIELDS.filter(
  (jtf) => jtf.dataType === 'string' || jtf.dataType === 'boolean'
)
